import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewReformularRacion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'reformular_racion',
        name: 'reformular_racion',
        component: ViewReformularRacion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]
export default router
